module.exports = __webpack_public_path__ + "images/traditional-3-a83a9c8d8f2cbe439d2baa7bfc3cd71e.jpg";